import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { tabPaneArr, data as _data } from './conf';
import { payrollSubProjectInfo } from '@/api/payroll';
import rdiff from 'recursive-diff';
export default {
  data: function data() {
    return {
      loading: false,
      activeStep: 0,
      activeObj: {},
      tabPaneArr: tabPaneArr,
      activeData: JSON.parse(JSON.stringify(_data)),
      id: Number(this.$route.params.id),
      dialogVisible: false,
      change_nosave: true,
      confirm: false,
      info: JSON.parse(JSON.stringify(_data.info))
    };
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    window.removeEventListener('popstate', window.pushStateFun, false);
    if (this.confirm) next();else {
      var diff = rdiff.getDiff(this.activeData.info, this.info);
      if (!diff.length) next();else {
        this.$confirm(this.$t('payroll_management_28'), this.$t('payroll_management_27'), {
          confirmButtonText: this.$t('submit_btn'),
          cancelButtonText: this.$t('cancel_btn'),
          type: 'warning'
        }).then(function () {
          next();
        }).catch(function () {});
      }
    }
  },
  computed: {
    calculate_state: function calculate_state() {
      var calculate_state = Number(this.activeData.info.calculate_state);
      return [3, 4].includes(calculate_state);
    },
    scheme_id: function scheme_id() {
      return !Number(this.activeData.payroll_sub_project_scheme_id);
    }
  },
  mounted: function mounted() {
    this.inif();
    this.preventBack();
  },
  methods: {
    preventBack: function preventBack() {
      var this_ = this;
      window.pushStateFun = function () {
        var diff = rdiff.getDiff(this_.activeData.info, this_.info);
        if (!diff.length) this_.handlerBack();else {
          this_.$confirm(this_.$t('payroll_management_28'), this_.$t('payroll_management_27'), {
            confirmButtonText: this_.$t('submit_btn'),
            cancelButtonText: this_.$t('cancel_btn'),
            type: 'warning'
          }).then(function () {
            this_.confirm = true;
            this_.handlerBack();
          }).catch(function () {
            var state = {
              title: null,
              url: document.UTL // 要禁掉的页面
            };
            /*
                三个参数：
                state：一个与指定网址相关的状态对象，popstate事件触发时，该对象会传入回调函数。如果不需要这个对象，此处可以填null。
                title：新页面的标题，但是所有浏览器目前都忽略这个值，因此这里可以填null。
                url：新的网址，必须与当前页面处在同一个域。浏览器的地址栏将显示这个网址。
              */
            window.history.pushState(state, null, document.UTL); // 要禁掉的页面
          });
        }
      };

      var state = {
        title: null,
        url: document.UTL // 要禁掉的页面
      };

      window.history.pushState(state, null, document.UTL); // 要禁掉的页面
      window.addEventListener('popstate', window.pushStateFun, false);
    },
    inif: function inif() {
      if (!this.$route.params.id) this.id = this.$s.get('sub_project_id');
      if (this.id) {
        this.activeData.sub_project_id = this.id;
        this.loadSubProjectInfo(this.id);
      }
      this.activeObj = this.tabPaneArr[this.activeStep];
    },
    loadSubProjectInfo: function loadSubProjectInfo(id) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, department_ids, staffs, staff_state, staff_formal;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 获取子项目信息
              res = {
                code: 1,
                data: {}
              };
              _context.next = 3;
              return payrollSubProjectInfo({
                sub_project_id: id
              });
            case 3:
              res = _context.sent;
              if (res && res.code === 1) {
                department_ids = [];
                if (res.data.department_ids && res.data.department_ids.length) {
                  res.data.department_ids.forEach(function (item) {
                    department_ids.push({
                      department_id: item.id,
                      department_name: item.name
                    });
                  });
                }
                staffs = [];
                if (Array.isArray(res.data.staff_ids)) {
                  res.data.staff_ids.forEach(function (item) {
                    staffs.push({
                      staff_id: item.staff_id || item.id,
                      staff_name: item.staff_name || item.name,
                      staff_name_en: item.staff_name_en,
                      staff_name_secondary: item.staff_name_secondary,
                      staff_name_th: item.staff_name_th || item.name,
                      avatar_url: item.avatar_url || '',
                      id: item.id || '',
                      name: item.name || ''
                    });
                  });
                }
                res.data.department_ids = department_ids;
                res.data.staff_ids = staffs;
                // 在职状态
                staff_state = res.data.staff_state && res.data.staff_state !== '0' ? res.data.staff_state.split(',') : [];
                res.data.staff_state = staff_state;
                // 员工属性
                staff_formal = res.data.staff_formal && res.data.staff_formal !== '0' ? res.data.staff_formal.split(',') : [];
                res.data.staff_formal = staff_formal;
                // 税
                res.data.tax_deduction_status = ['3', '4'].includes(res.data.tax_deduction_status) ? res.data.tax_deduction_status : '';
                _this.activeData.payroll_sub_project_scheme_id = res.data.payroll_sub_project_scheme_id;
                _this.activeData.info = res.data;
                _this.info = JSON.parse(JSON.stringify(res.data));
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handlerBack: function handlerBack() {
      this.$router.push({
        path: '/payroll/wage',
        query: {
          name: this.$route.query.name
        }
      });
    },
    prev: function prev() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // 上一步
              _this2.activeData.sub_project_id = _this2.$s.get('sub_project_id') || _this2.id;
              _this2.confirm = false;
              _this2.activeStep--;
              _this2.activeObj = _this2.tabPaneArr[_this2.activeStep];
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    next: function next() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // 下一步
              _this3.activeData.sub_project_id = _this3.$s.get('sub_project_id') || _this3.id;
              _context3.prev = 1;
              _this3.loading = true;
              if (!(_this3.activeObj.title === 'step1')) {
                _context3.next = 7;
                break;
              }
              _context3.next = 6;
              return _this3.$refs[_this3.activeObj.title].saveData();
            case 6:
              res = _context3.sent;
            case 7:
              if (res) {
                _this3.confirm = true;
                _this3.$message({
                  type: 'success',
                  message: _this3.$t('160')
                }); // 保存成功
                _this3.activeStep++;
                _this3.activeObj = _this3.tabPaneArr[_this3.activeStep];
              }
              _this3.loading = false;
              _context3.next = 15;
              break;
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](1);
              _this3.loading = false;
              res = _context3.t0;
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 11]]);
      }))();
    },
    onSave: function onSave(val) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              if (!_this4.calculate_state) {
                _context4.next = 5;
                break;
              }
              _this4.confirm = true;
              _this4.$router.push({
                path: '/payroll/wageSalary/' + (_this4.$s.get('sub_project_id') || _this4.id),
                query: {
                  name: _this4.$route.query.name
                }
              });
              return _context4.abrupt("return");
            case 5:
              _context4.next = 7;
              return _this4.$refs[_this4.activeObj.title].saveData();
            case 7:
              res = _context4.sent;
              if (res && res.code === 1) {
                _this4.confirm = true;
                _this4.$message({
                  type: 'success',
                  message: _this4.$t('160')
                });
                if (val) {
                  _this4.$router.push({
                    path: '/payroll/wageSalary/' + (_this4.$s.get('sub_project_id') || _this4.id),
                    query: {
                      name: _this4.$route.query.name
                    }
                  });
                }
              }
              _context4.next = 14;
              break;
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](0);
              res = _context4.t0;
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 11]]);
      }))();
    },
    handleAdd: function handleAdd() {
      this.confirm = true;
      this.$router.push('/payroll/salary-scheme');
    }
  },
  beforeDestroy: function beforeDestroy() {
    // 删除本地存储的sub_project_id
    this.$s.remove('sub_project_id');
  }
};